export default __webpack_public_path__ + "static/media/151-demostration.166d5faf.png";